import { stringTrim } from '../../../../../../helpers/stringTrim';

export const transformRoomFormValues = (values) => {
  const data = {
    name: stringTrim(values.name),
    number: stringTrim(values.number),
    floor: Number(values.floor),
    area: Number(values.area.replace(',', '.')),
    price: Number(values.price.replace(',', '.')),
    comment: stringTrim(values.comment),
    isMop: values.isMop,
    status: { id: values.status },
    type: { id: values.type },
    landLords: Array.from(
      new Set(
        values.landLordKeys
          .filter((key) => Boolean(values[`landLord-${key}`]))
          .map((key) => values[`landLord-${key}`])
      )
    ).map((id) => ({ id })),
    description: stringTrim(values.description),
    cadastralNumber: stringTrim(values.cadastralNumber),
    companyServices: values.companyServices
      ? values.companyServices.map((serviceId) => ({
          id: serviceId,
        }))
      : [],
  };

  return data;
};
